import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'deliveryQualifierCd' })
export class DeliveryQualifierCdPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    switch ((value || '').toUpperCase()) {
      case 'A':
        return 'Over';
      case 'B':
        return 'Trapped';
      case 'C':
        return 'Hold for Customer';
      case 'D':
        return 'Undelivered';
      case 'E':
        return 'Appointment';
      case 'F':
        return 'Spotted';
      case 'G':
        return 'Cartage';
      case 'H':
        return 'Attempted';
      case 'J':
        return 'All Short';
      case 'K':
        return 'Partial Short';
      case 'L':
        return 'Refused';
      case 'M':
        return 'Damaged';
      case 'N':
        return 'Suspense';
      case 'O':
        return 'Wait';
      case 'P':
        return 'Purge Blocked';
      case 'R':
        return 'Returned';
      case 'T':
        return 'Transfer';
      case 'Z':
        return 'Final Deliver';
    }

    return value;
  }
}
